module.exports = __webpack_public_path__ + "img/edit-tools.f36f16a8.png";